import { STORAGE_USER } from "@weco/suite-client";
import type { SuiteChromeUser } from "./types";

export function readUserFromStorage(): SuiteChromeUser | null {
  if (typeof localStorage === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SuiteChromeUser;
  } catch {
    return null;
  }
}
